import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, Users2Icon, TargetIcon, ClockIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
const getDifferentiators = (t: any) => [{
  title: t('diff_1_title'),
  description: t('diff_1_desc'),
  icon: CheckCircle2Icon
}, {
  title: t('diff_2_title'),
  description: t('diff_2_desc'),
  icon: Users2Icon
}, {
  title: t('diff_3_title'),
  description: t('diff_3_desc'),
  icon: TargetIcon
}, {
  title: t('diff_4_title'),
  description: t('diff_4_desc'),
  icon: ClockIcon
}];
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  const differentiators = getDifferentiators(t);
  return <section id="about" className="relative bg-white" data-id="element-317">
      <div className="flex flex-col lg:flex-row min-h-[600px]" data-id="element-318">
        {/* Left Side: Dark Navy Stats */}
        <div className="lg:w-5/12 bg-navy text-white p-12 lg:p-20 flex flex-col justify-center relative overflow-hidden" data-id="element-319">
          {/* Background Pattern */}
          <div className="absolute inset-0 z-0 opacity-5 bg-grid-pattern" data-id="element-320" />

          <div className="relative z-10" data-id="element-321">
            <motion.h2 className="text-3xl lg:text-4xl font-extrabold mb-12" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} data-id="element-322">
              {t('why_title')}
            </motion.h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-323">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} data-id="element-324">
                <div className="text-4xl font-extrabold text-electric-light mb-2" data-id="element-325">
                  {t('why_stat_1_val')}
                </div>
                <div className="text-slate-300 font-medium" data-id="element-326">
                  {t('why_stat_1_label')}
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} data-id="element-327">
                <div className="text-4xl font-extrabold text-electric-light mb-2" data-id="element-328">
                  {t('why_stat_2_val')}
                </div>
                <div className="text-slate-300 font-medium" data-id="element-329">
                  {t('why_stat_2_label')}
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} data-id="element-330">
                <div className="text-4xl font-extrabold text-electric-light mb-2" data-id="element-331">
                  {t('why_stat_3_val')}
                </div>
                <div className="text-slate-300 font-medium" data-id="element-332">
                  {t('why_stat_3_label')}
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4
            }} data-id="element-333">
                <div className="text-4xl font-extrabold text-electric-light mb-2" data-id="element-334">
                  {t('why_stat_4_val')}
                </div>
                <div className="text-slate-300 font-medium" data-id="element-335">
                  {t('why_stat_4_label')}
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Right Side: Differentiators */}
        <div className="lg:w-7/12 p-12 lg:p-20 flex flex-col justify-center bg-slate-50" data-id="element-336">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-337">
            {differentiators.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            delay: index * 0.1
          }} className="flex flex-col" data-id="element-338">
                <div className="w-12 h-12 rounded-lg bg-white shadow-sm border border-slate-100 flex items-center justify-center mb-5 text-electric" data-id="element-339">
                  <item.icon className="w-6 h-6" data-id="element-340" />
                </div>
                <h3 className="text-xl font-bold text-navy mb-3" data-id="element-341">
                  {item.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-342">
                  {item.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}